export const glass = [0.12, 0.15, 0.18];
